import {
  getDetailsTabRoutes,
  getSelectableResult
} from "../../../utility/route";
import { childOfOrEqual } from "../../../router/functions";

export const royaltyAccountsListLDTRoutes = getDetailsTabRoutes(
  "royalty_accounts",
  "royalty_account_id"
);
export const royaltyContractsListLDTRoutes = getDetailsTabRoutes(
  "contracts",
  "contract_id"
);
export const statementsListLDTRoutes = getDetailsTabRoutes(
  "statements",
  "royalty_period_id"
);

export const getStatementDetailsSelectable = getSelectableResult(
  statementsListLDTRoutes
);
export const getAccountsDetailsSelectable = getSelectableResult(
  royaltyAccountsListLDTRoutes
);
export const getContractsDetailsSelectable = getSelectableResult(
  royaltyContractsListLDTRoutes
);
export const moduleRoutes = [
  royaltyAccountsListLDTRoutes,
  royaltyContractsListLDTRoutes,
  statementsListLDTRoutes
];

const detailsRoutes = moduleRoutes.map(m => m.names.details);

export const childOfOrEqualDetails = route => {
  return detailsRoutes.map(r => childOfOrEqual(r)).some(f => f(route.name));
};
